module.exports = {"id":"234822","name":"Abbubaker Mobara","rating":"72","photo":"./data/images/photos/0/234822.png","club":{"name":"Orlando Pirates","logo":"./data/images/clubs/OrlandoPirates.png"},"positions":["DD","DC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AbbubakerMobara0.json
// module id = 51
// module chunks = 0